import * as yup from 'yup';
import * as Schema from '../schemaFields';

export const templateStartGameValidationSchema = yup.object({
  date: Schema.requiredDate,
  startHour: Schema.requiredDate,
  endHour: Schema.endDateBasedOnStartDate,
  numOfPlayers: Schema.requiredNumber,
});
